<priva-content-template>
    <priva-content-header />
    <app-signin-form
        [title]="(title$ | async) || '' | translate"
        (authorized)="onAuthorized($event)"
        [requiredRoles]="requiredRoles$ | async"
        [forceScanIfPossible]="true"
    />
</priva-content-template>
